<script lang="ts">
	export let name: string;
	import * as openpgp from 'openpgp';
    import { key } from './keys';
	let files;

	$: if (files) {
		for (const file of files) {
			const reader = new FileReader();
			reader.addEventListener('load', async (event) => {

				const result = await enc(JSON.stringify({
					fileName: file.name,
					content: btoa(event.target.result.toString()),
				}));
				const dest: HTMLTextAreaElement = document.getElementById("dest") as HTMLTextAreaElement;
				dest.value = result;

			});
			reader.readAsBinaryString(file);

		}
	}

	async function enc(text: string): Promise<string> {
		const publicKey = await openpgp.readKey({ armoredKey: key });

		const encrypted = await openpgp.encrypt({
        message: await openpgp.createMessage({ text }), // input as Message object
        encryptionKeys: publicKey,
    });
	return encrypted;
	}

	async function doEncrypt() {
		const src: HTMLTextAreaElement = document.getElementById('src') as HTMLTextAreaElement;
		const result = await enc(src.value);
		const dest: HTMLTextAreaElement = document.getElementById("dest") as HTMLTextAreaElement;
		dest.value = result;
	}
</script>

<main>
	<h1>MELD MESSAGE ENCRYPT</h1>
	<h2>Paste/write the message in the top input field (marked with Text) or select a file</h2>
	<h3>When done, click on the encrypt button.</h3>
	<h3>Encrypted message will be displayed in the bottom field.</h3>
	<h3>Copy the content from the bottom field and send it to the recipient.</h3>

	<input type="file" bind:files name="file">
	<label for="src">Text</label>
	<textarea id="src"></textarea>
	<br>
	<hr>
	<button on:click={doEncrypt}>ENCRYPT</button>
	<hr>
	<label for="dest">Encrypted</label>
	<textarea id="dest" readonly></textarea>

</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	textarea {
		width: 100%;
		display: block;
		min-height: 180px;
	}

	label {
		width: 100%;
		display: block;
		text-align: left;
	}
</style>